// extracted by mini-css-extract-plugin
module.exports = {"root":"Selectors_root__UHw4V"};